module.exports = __webpack_public_path__ + "e5cf12c53f8eb1c1dae49434e68664ad.jpg";